<ng-container *sm-has-env-flag="'auroraV1'">
    <aurora-button
        variant="ghost"
        iconLeft="plus"
        [loading]="loading"
        [disabled]="loading"
        (click)="tryCreateNewAccount()">
        New {{ "Account" | smNomenclatureByRegion : null | async }}
    </aurora-button>
</ng-container>

<ng-container *sm-has-not-env-flag="'auroraV1'">
    <button unity-button class="ghost on_dark" (click)="tryCreateNewAccount()">
        <svg class="unity-icon-plus" *ngIf="!loading">
            <use xlink:href="#unity-icon-plus"></use>
        </svg>
        <svg class="icon-completing" *ngIf="loading">
            <use xlink:href="#icon-completing"></use>
        </svg>
        New {{ "Account" | smNomenclatureByRegion : null | async }}
    </button>
</ng-container>
